export const FETCH_DATA_REQUEST_BRAND = "FETCH_DATA_REQUEST_BRAND";
export const FETCH_DATA_SUCCESS_BRAND = "FETCH_DATA_SUCCESS_BRAND";
export const FETCH_DATA_FAILURE_BRAND = "FETCH_DATA_FAILURE_BRAND";